import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import habilitarVendasEmLoteNoSite from '../../actions/itinerario/habilitarVendasEmLoteNoSite';
import {showSuccessMsg} from '../../util/messagesUtil';

const DIAS_SEMANA = [
    {label: 'Dom', value: 'SUNDAY'},
    {label: 'Seg', value: 'MONDAY'},
    {label: 'Ter', value: 'TUESDAY'},
    {label: 'Qua', value: 'WEDNESDAY'},
    {label: 'Qui', value: 'THURSDAY'},
    {label: 'Sex', value: 'FRIDAY'},
    {label: 'Sab', value: 'SATURDAY'},
];

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class ModalHabilitarVendasEmLoteNoSite extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            dataInicio: null, dataFim: null, diasSelecionados: [], habilitadoSite: true
        }
    }

    exibirDiasSemana() {
        return DIAS_SEMANA.map(it => <p key={it.value}
                                        className={this.state.diasSelecionados.includes(it.value) ? 'dot selected ml-1' : 'dot ml-1'}
                                        onClick={() => this.selecionarDia(it.value)}>{it.label}</p>)
    }

    selecionarDia(dia) {
        const lista = this.state.diasSelecionados;
        if (lista.includes(dia)) {
            this.setState({diasSelecionados: lista.filter(it => it !== dia)})
        } else {
            lista.push(dia);
            this.setState({diasSelecionados: lista})
        }
    }

    handleChecked() {
        this.setState({ habilitadoSite: !this.state.habilitadoSite });
    }

    montarParametroItinerario() {
        return {
            dataInicio: moment(this.state.dataInicio).format('DD/MM/YYYY'),
            dataFim: moment(this.state.dataFim).format('DD/MM/YYYY'),
            diasSemana: this.state.diasSelecionados,
            habilitadoSite: this.state.habilitadoSite,
            empresaId: this.props.empresaSelecionada.id,
            rotaId: this.props.rotaSelecionada.value,
        }
    }

    submit() {
        const parametros = this.montarParametroItinerario();
        this.props.habilitarVendasEmLoteNoSite(parametros)
            .then(() => {
                showSuccessMsg(`Vendas ${parametros.habilitadoSite ? 'habilitadas':'desabilitadas'} no site com sucesso`);
                this.fecharModal();
                this.props.buscarItinerarios();
            })
    }

    fecharModal() {
        $('#modalHabilitarVendasEmLoteNoSite')
            .modal('hide');
        $('#modalHabilitarVendasEmLoteNoSite')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.props.reset('formularioHabilitarVendasEmLoteNoSite');
        this.setState({dataInicio: null, dataFim: null, diasSelecionados: [], habilitadoSite: false});
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <>
                <div className="vx-modal-body">
                    <form id="form-habilitar-vendas-site" onSubmit={handleSubmit(this.submit)}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Informações básicas</legend>
                            <div className="col-12 col-sm-4 col-md-4 mt-2">
                                <label>Opera em quais dias da semana?</label>
                                <div className='form-row'>
                                    {this.exibirDiasSemana()}
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 col-md-2 mt-2">
                                <label>Quando começa?</label>
                                {this.exibirCalendario(true)}
                            </div>
                            <div className="col-12 col-sm-4 col-md-2 mt-2">
                                <label>Quando encerra?</label>
                                {this.exibirCalendario()}
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 mt-3" style={{display: 'flex', alignItems: 'center'}}>
                                <span className='mt-2'></span>
                                <div className='form-group form-check'>
                                    <input type="checkbox" name='habilitadoSite'
                                            className='form-check-input' onChange={this.handleChecked} value={this.state.habilitadoSite} checked={this.state.habilitadoSite} />
                                        <label className='form-check-label'>Vender no site?</label>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div className="vx-modal-footer">
                    <button type="submit" form="form-habilitar-vendas-site"
                        disabled={invalid || submitting || !this.state.dataInicio
                            || !this.state.dataFim || !this.state.diasSelecionados.length}
                        className="vx-btn-primary">
                        <i className="material-icons" style={{ fontSize: '16px' }}>save</i> Salvar
                    </button>
                </div>
            </>
        );
    }

    render() {
        return (
            <div className="modal fade show" id='modalHabilitarVendasEmLoteNoSite' role='dialog'
            aria-labelledby='modalHabilitarVendasEmLoteNoSite' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">public</i>
                                <span className="vx-modal-title">Alterar Venda no Site</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        {this.formulario()}
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        habilitarVendasEmLoteNoSite
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioHabilitarVendasEmLoteNoSite',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalHabilitarVendasEmLoteNoSite));
